var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from "classnames";
import { useEffect, useState } from "react";
import Spinner from "@cloudscape-design/components/spinner";
import { useWindowEventListener } from "../../common/hooks/useWindowEventListener";
import { usePopper } from "react-popper";
import StatusIndicator from "@cloudscape-design/components/status-indicator";
/**
 * Internal copy/paste content preview element with popover
 */
export var InternalContentPreview = function (props) {
    var _a, _b, _c;
    var _d = useState(false), focused = _d[0], setFocused = _d[1];
    useEffect(function () {
        setFocused(document.hasFocus());
    }, []);
    useWindowEventListener("focus", function () {
        setFocused(true);
    });
    useWindowEventListener("blur", function () {
        setFocused(false);
    });
    var contentPreviewEl;
    if (props.isLoading) {
        contentPreviewEl = _jsx(Spinner, {});
    }
    else if (props.content) {
        contentPreviewEl = _jsx("pre", __assign({ className: "clipboard_text" }, { children: props.content }));
    }
    else if (props.placeholder) {
        contentPreviewEl = (_jsx("span", __assign({ className: "placeholder" }, { children: props.placeholder })));
    }
    var _e = useState(null), referenceElement = _e[0], setReferenceElement = _e[1];
    var _f = useState(), popperElement = _f[0], setPopperElement = _f[1];
    var _g = usePopper(referenceElement, popperElement, {
        modifiers: [
            { name: "arrow", options: { element: "data-popper-arrow" } },
            { name: "offset", options: { offset: [0, 8] } },
        ],
        placement: "top",
    }), styles = _g.styles, attributes = _g.attributes, update = _g.update;
    /**
     * React popper will not automatically re-calculate the position.
     * We need to manually update the popper instance asynchronously.
     * https://popper.js.org/docs/v2/constructors/#instance
     */
    useEffect(function () {
        update && update();
    }, [(_a = props.popover) === null || _a === void 0 ? void 0 : _a.message]);
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ ref: setReferenceElement, className: classNames("content_preview", { focused: focused }), "aria-readonly": "true" }, { children: contentPreviewEl })), _jsxs("div", __assign({ role: "tooltip", ref: setPopperElement, style: styles.popper }, attributes.popper, { className: classNames("popover", {
                    visible: props.popoverVisible,
                }) }, { children: [_jsx("div", { "data-popper-arrow": true, className: "popover-arrow", style: styles.arrow }), _jsx(StatusIndicator, __assign({ type: (_b = props.popover) === null || _b === void 0 ? void 0 : _b.status }, { children: (_c = props.popover) === null || _c === void 0 ? void 0 : _c.message }))] }))] }));
};
